<template>
  <v-row>
    <v-col cols="12">
      <v-data-table :headers="headers" :items="items">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>PLANTILLAS</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="abrirDialog()">Nuevo</v-btn>
          </v-toolbar>
        </template>

        <template v-slot:[`item.action_editar`]="{ item }">
          <v-btn icon @click="editarRegistro(item)">
            <v-icon>tab</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-col>

    <v-dialog v-model="dialog" width="1000" scrollable persistent>
      <v-card>
        <v-card-title>
          <v-toolbar flat>
            <v-toolbar-title>Nuevo</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text @click="agregarVariable()"> + Agregar variable </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-row>
              <v-col cols="3">
                <v-text-field
                  v-model="id"
                  label="ID"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="3" v-if="!checkbox_encabezado">
                <v-text-field
                  v-model="encabezado"
                  label="Encabezado"
                  outlined
                  dense
                  hide-details
                  :disabled="encabezado_solo_lectura"
                ></v-text-field>
              </v-col>
              <v-col cols="3" v-if="checkbox_encabezado">
                <v-autocomplete
                  v-model="encabezado"
                  :items="items_cabina"
                  label="Nombre"
                  outlined
                  dense
                  hide-details
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="2" align-self="start">
                <v-checkbox
                  v-model="checkbox_encabezado"
                  label="Variable"
                  hide-details
                  class="ma-0"
                  @change="checkboxEncabezado()"
                ></v-checkbox>
              </v-col>
              <v-col cols="4">
                <v-textarea
                  v-model="mensaje_encabezado"
                  label="Mensaje"
                  outlined
                  dense
                  counter="60"
                  auto-grow
                ></v-textarea>
              </v-col>
            </v-row>
            <v-col cols="12" md="7" class="pa-0">
              <v-row v-for="(item, i) in items_variables" :key="i">
                <v-col cols="2">
                  <v-text-field
                    v-model="item.clave"
                    label="Variable"
                    readonly
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="7" v-if="!item.es_variable_cabina">
                  <v-text-field
                    v-model="item.valor"
                    label="Texto"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="7" v-if="item.es_variable_cabina">
                  <v-autocomplete
                    v-model="item.nombre_variable_cabina"
                    :items="items_cabina"
                    label="Nombre"
                    outlined
                    dense
                    hide-details
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="2">
                  <v-checkbox
                    v-model="item.es_variable_cabina"
                    label="Variable"
                    hide-details
                    class="ma-0"
                  ></v-checkbox>
                </v-col>
                <v-col cols="1">
                  <v-btn icon @click="confirmarEliminar(item)">
                    <v-icon>far fa-trash-alt</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="5" class="pr-0">
              <v-textarea
                v-model="mensaje_plantilla"
                label="Mensaje"
                outlined
                dense
                auto-grow
                counter="1024"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="bandera_acciones == 1"
            color="primary"
            @click="crearPlantilla()"
            >Guardar</v-btn
          >
          <v-btn
            v-if="bandera_acciones == 2"
            color="primary"
            @click="actualizarPlantilla()"
            >Actualizar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text @click="cerrarDialog()">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_confirmar_eliminar" width="500">
      <v-card>
        <v-card-title>¿Está seguro de eliminar la variable?</v-card-title>
        <v-card-text></v-card-text>
        <v-card-actions>
          <v-btn color="red" dark @click="eliminarVariable()">Eliminar</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="dialog_confirmar_eliminar = !dialog_confirmar_eliminar"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Axios from "axios";

export default {
  data: () => ({
    dialog: false,
    headers: [
      { text: "ID", value: "identificador_wa_api" },
      { text: "Encabezado variable", value: "encabezado" },
      { text: "Encabezado mensaje", value: "mensaje_encabezado" },
      { text: "Editar", value: "action_editar" },
    ],
    items: [],
    checkbox_encabezado: false,
    contador_variable: 1,
    bandera_acciones: 1,
    items_variables: [],
    id_plantilla_wa_api: 0,
    id: "",
    encabezado: "",
    encabezado_solo_lectura: true,
    variable_seleccionada: "",
    dialog_confirmar_eliminar: false,
    items_cabina: [],
    nombre_variable_cabina: "",
    mensaje_plantilla: "",
    mensaje_encabezado: "",
  }),
  created() {
    this.listarPlantillas();
    this.descargarCamposCabina();
  },
  methods: {
    abrirDialog() {
      this.bandera_acciones = 1;
      this.dialog = true;
    },
    agregarVariable() {
      this.items_variables.push({
        status: "nuevo",
        clave: "{{" + this.contador_variable + "}}",
        valor: "Mensaje " + this.contador_variable,
        es_variable_cabina: false,
        nombre_variable_cabina: "",
        correlativo: this.contador_variable,
      });
      this.contador_variable++;
    },
    cerrarDialog() {
      this.dialog = false;
      this.dialog_confirmar_eliminar = false;
      this.items_variables = [];
      this.id = "";
      this.encabezado = "";
      this.checkbox_encabezado = false;
      this.contador_variable = 1;
      this.bandera_acciones = 1;
      this.variable_seleccionada = "";
      this.mensaje_plantilla = "";
      this.mensaje_encabezado = "";
    },
    alertaSuccess(mensaje) {
      this.$toast.success(mensaje, {
        position: "top-right",
        closeOnClick: false,
        draggable: false,
        timeout: 0,
      });
    },
    alertaError(mensaje) {
      this.$toast.error(mensaje, {
        position: "top-right",
        closeOnClick: false,
        draggable: false,
        timeout: 0,
      });
    },
    checkboxEncabezado() {
      if (this.checkbox_encabezado) {
        this.encabezado_solo_lectura = false;
      } else if (!this.checkbox_encabezado) {
        this.encabezado_solo_lectura = true;
        this.encabezado = "";
      }
    },
    listarPlantillas() {
      Axios.get("api/WhatsAppApiPlantillas/Listar").then((response) => {
        this.items = response.data;
      });
    },
    listarParametros(id_plantilla_wa_api) {
      Axios.get(
        "api/WhatsAppApiParametrosPlantillas/Listar/" + id_plantilla_wa_api
      ).then((response) => {
        //console.log(response.data);
        for (var i = 0; i < response.data.length; i++) {
          this.contador_variable++;
        }
        this.items_variables = response.data;
      });
    },
    editarRegistro(item) {
      //console.log(item);
      this.id_plantilla_wa_api = item.id_plantilla_wa_api;
      this.id = item.identificador_wa_api;
      this.encabezado = item.encabezado;
      this.checkbox_encabezado = item.encabezado_variable;
      this.mensaje_plantilla = item.mensaje_plantilla;
      this.mensaje_encabezado = item.mensaje_encabezado;
      this.bandera_acciones = 2;

      this.listarParametros(item.id_plantilla_wa_api);

      this.dialog = true;
    },
    crearPlantilla() {
      Axios.post("api/WhatsAppApiPlantillas/Crear", {
        identificador_wa_api: this.id,
        encabezado: this.encabezado,
        encabezado_variable: this.checkbox_encabezado,
        mensaje_plantilla: this.mensaje_plantilla,
        mensaje_encabezado: this.mensaje_encabezado,
        parametros: this.items_variables,
      })
        .then(() => {
          this.cerrarDialog();
          this.listarPlantillas();
          this.alertaSuccess("Plantilla creado con exito");
        })
        .catch(() => {
          this.alertaError("No se pudo crear la plantilla");
        });
    },
    actualizarPlantilla() {
      Axios.put("api/WhatsAppApiPlantillas/Actualizar", {
        id_plantilla_wa_api: this.id_plantilla_wa_api,
        identificador_wa_api: this.id,
        encabezado: this.encabezado,
        encabezado_variable: this.checkbox_encabezado,
        mensaje_plantilla: this.mensaje_plantilla,
        mensaje_encabezado: this.mensaje_encabezado,
        parametros: this.items_variables,
      })
        .then(() => {
          this.cerrarDialog();
          this.listarPlantillas();
          this.alertaSuccess("Plantilla actualizado con exito");
        })
        .catch(() => {
          this.alertaError("No se pudo actualizar la plantilla");
        });
    },
    confirmarEliminar(item) {
      this.dialog_confirmar_eliminar = true;
      this.variable_seleccionada = item;
    },
    eliminarVariable() {
      //console.log(this.variable_seleccionada);
      if (this.variable_seleccionada.status == "nuevo") {
        var index = this.items_variables.findIndex(
          (item) => item.clave == this.variable_seleccionada.clave
        );
        if (index != -1) {
          this.items_variables.splice(index, 1);
          this.dialog_confirmar_eliminar = false;
          this.variable_seleccionada = "";
        }
      } else {
        Axios.delete(
          "api/WhatsAppApiParametrosPlantillas/EliminarParametro/" +
            this.variable_seleccionada.id_parametros_plantilla_wa_api
        )
          .then(() => {
            this.cerrarDialog();
            this.listarPlantillas();
            this.alertaSuccess("Plantilla eliminada con exito");
          })
          .catch(() => {
            this.alertaError("No se pudo eliminar la plantilla");
          });
      }
    },
    descargarCamposCabina() {
      Axios.get("api/WhatsAppApiPlantillas/DescargarCamposCabina").then(
        (response) => {
          this.items_cabina = response.data;
        }
      );
    },
  },
};
</script>